import React from "react";
import Select from "react-select";
import { FormGroup, FormLabel } from "react-bootstrap";
import { excelDateToJSDate } from "../../generic";
import moment from "moment";

const SelectProperty = ({
  propertyName,
  prefilledContent,
  options,
  onChange,
  isClearable = true,
  letter,
  propertySample,
  key,
  placeholder
}) => {
  const customStyles = {
    control: provided => ({
      ...provided,
      minHeight: "calc(1.5em + .75rem + 2px)",
      fontSize: "1rem",
      padding: ".375rem .75rem",
      borderRadius: ".25rem",
      borderColor: "rgb(206, 212, 218)"
    }),
    menu: provided => ({
      ...provided,
      zIndex: 10
    })
  };

  let displayPropertySample = propertySample;
  // Debugging de l'affichage de la date
  if (/date/i.test(propertyName) && typeof displayPropertySample === "number") {
    displayPropertySample = moment(
      excelDateToJSDate(displayPropertySample)
    ).format("D/M/YYYY");
  }

  return (
    <FormGroup>
      <FormLabel>
        <strong>Colonne {propertyName}</strong>
        Exemple de donnée : {displayPropertySample}
      </FormLabel>
      <Select
        styles={customStyles}
        defaultValue={prefilledContent}
        options={options}
        onChange={onChange}
        placeholder={placeholder}
        isClearable={isClearable}
      />
    </FormGroup>
  );
};

export default SelectProperty;
